import { render, staticRenderFns } from "./ConfigEditForm.vue?vue&type=template&id=3b86e3cf&scoped=true&"
import script from "./ConfigEditForm.vue?vue&type=script&lang=ts&"
export * from "./ConfigEditForm.vue?vue&type=script&lang=ts&"
import style0 from "./ConfigEditForm.vue?vue&type=style&index=0&id=3b86e3cf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b86e3cf",
  null
  
)

export default component.exports